export default __webpack_public_path__ + "static/media/errorCover.25bdb9b5.jpg";